// extracted by mini-css-extract-plugin
export default {"section":"NoteSection_section__nHiHn","textContainer":"NoteSection_textContainer__7vajy"};